import React, { useState } from "react";
import {
  Dimensions,
  Image,
  ImageBackground,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import ReactMarkdown from "react-markdown";
import BounceLoader from "react-spinners/BounceLoader";

import Menu from "../../menu";
import style from "../../../Styles/CheckIn";
import globalstyle from "../../../Styles/Globals/globals";
import {
  getMultimedia,
  getRecursText,
  getRecursURL,
} from "../../../Functions/getRecurs";

function Checkin(RouterData) {
  const { itinerari, currentItinerari, poi, recursos, projecte, idioma } =
    RouterData.route.params;

  const poiData = itinerari.pois.find((e) => e.id === poi.id);
  const premi = projecte.premis.find((e) => e.id === poiData.premi);
  const punts = premi?.punts || 100;
  const [continuar, setContinuar] = useState(false);
  const [loading, setLoading] = useState(false);

  if (!premi) {
    alert("El poi no té premi!");
  }

  // useEffect(() => {
  //     // document.getElementById('audio').play();
  // }, []);

  const _paintImage = () => {
    if (poiData.Tipus === "Joc360") {
      return (
        <iframe
          src={poiData.Url_Joc360}
          allow="fullscreen;geolocation;camera;gyroscope;accelerometer;magnetometer"
          style={{
            height: Dimensions.get("screen").height * (13 / 15) * 0.55,
            width: Dimensions.get("screen").height * (13 / 15) * 0.5,
            resizeMode: "contain",
            borderRadius: 5,
          }}
        />
      );
    }
    if (continuar) {
      return (
        <>
          <View
            style={{
              flex: 30,
              width: "80%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Image
              resizeMode="contain"
              style={style.image}
              source={{ uri: getMultimedia(poiData, "Checkin1") }}
            />
          </View>
          <View
            style={[
              { flex: 20, justifyContent: "center", alignItems: "center" },
              style.descripcio,
            ]}
          >
            <ScrollView
              showsHorizontalScrollIndicator={false}
              showsVerticalScrollIndicator={false}
            >
              <ReactMarkdown>
                {poiData[`descripcioDetallada${idioma}`]}
              </ReactMarkdown>
            </ScrollView>
          </View>
        </>
      );
    }
    return (
      <>
        <View
          style={{
            flex: 30,
            width: "80%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Image
            resizeMode="contain"
            style={style.image}
            source={{ uri: getMultimedia(poiData, "Checkin2") }}
          />
        </View>
        <View
          style={[
            { flex: 20, justifyContent: "center", alignItems: "center" },
            style.descripcio,
          ]}
        >
          <ScrollView
            showsHorizontalScrollIndicator={false}
            showsVerticalScrollIndicator={false}
          >
            {poiData[`Descripcio${idioma}`] ? (
              <ReactMarkdown>{poiData[`Descripcio${idioma}`]}</ReactMarkdown>
            ) : (
              <ReactMarkdown>
                {poiData[`descripcioDetallada${idioma}`]}
              </ReactMarkdown>
            )}
          </ScrollView>
        </View>
      </>
    );
  };

  const _renderBoto = () => {
    if (loading) {
      setTimeout(() => {
        setLoading(false);
        setContinuar(true);
      }, 1000);

      return (
        <BounceLoader
          size={50}
          color={"#006fb7"}
          loading={loading}
          speedMultiplier={1.5}
        />
      );
    } else {
      if (continuar) {
        return (
          <TouchableOpacity
            onPress={() => {
              currentItinerari.pois.find((e) => e.id === poi.id).punts = punts;

              RouterData.navigation.navigate("Premi", RouterData.route.params);
            }}
          >
            <Text style={globalstyle.botoContinuar}>
              {getRecursText(recursos, "text_continuar", idioma)}
            </Text>
          </TouchableOpacity>
        );
      } else {
        return (
          <TouchableOpacity
            onPress={() => {
              setLoading(true);
            }}
          >
            <Text style={globalstyle.botoContinuar}>
              {getRecursText(recursos, "check_in", idioma)}
            </Text>
          </TouchableOpacity>
        );
      }
    }
  };

  return (
    <View style={{ flex: 1 }}>
      <ImageBackground
        source={{
          uri: getRecursURL(recursos, "background_default", idioma),
        }}
        style={{ flex: 1 }}
      >
        <View
          style={{
            flex: 20,
            justifyContent: "center",
            alignItems: "center",
            alignSelf: "center",
            width: "90%",
          }}
        >
          <ScrollView
            contentContainerStyle={style.scroll}
            showsHorizontalScrollIndicator={false}
            showsVerticalScrollIndicator={false}
          >
            <View
              style={{
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Text style={style.titol}> {poiData["Nom" + idioma]} </Text>
            </View>
          </ScrollView>
        </View>
        <View style={{ flex: 5 }} />
        <View
          style={{ flex: 50, justifyContent: "center", alignItems: "center" }}
        >
          {_paintImage()}
        </View>
        {/* <View style={{flex:5}} /> */}
        <View
          style={{ flex: 10, justifyContent: "center", alignItems: "center" }}
        >
          {_renderBoto()}
        </View>
        <View style={{ flex: 10 }}><Menu projecte={RouterData.route.params}></Menu></View>
      </ImageBackground>
    </View>
  );
}

export default Checkin;
